// Whether this browser currently has a network connection.
//
// Why the shell needs it: TanStack Query's default network mode PAUSES a
// fetch while the browser is offline rather than failing it, so no error ever
// reaches the footer. Measured on 2026-08-20: sixty seconds offline on Live
// Calls left the status bar reading "Stale. The newest evidence in this
// workspace is 6 days old ... The connected route is a read-only import with
// no heartbeat." That sentence is about the Telegram import. It says nothing
// about the fact that the browser could not reach the workspace at all, which
// is what feature contract 2.5 asks this bar to report.
//
// navigator.onLine is a floor, not a guarantee: false always means offline,
// true only means an interface is up. That is enough here, because the state
// it drives is Stale or Provider unavailable, and a wrong true simply leaves
// the previous behaviour in place.
import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void): () => void {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
  };
}

function read(): boolean {
  return typeof navigator === 'undefined' ? true : navigator.onLine !== false;
}

export function useOnline(): boolean {
  return useSyncExternalStore(subscribe, read, () => true);
}
